import { render, staticRenderFns } from "./AxTextBox.vue?vue&type=template&id=6c1d7257"
import script from "./AxTextBox.vue?vue&type=script&lang=ts"
export * from "./AxTextBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports